import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import ContentLayout from '@/layouts/content-layout'
import ShopFormView from '@/sections/shops/view/shop-form-view'

export default function ShopFormPage() {
  const location = useLocation()

  // Determine title based on pathname
  const title = useMemo(() => {
    if (location.pathname.includes('/shops/create')) {
      return 'เพิ่มร้านค้า'
    }
    if (location.pathname.match(/^\/shops\/[^/]+\/edit/)) {
      return 'แก้ไขร้านค้า'
    }
    return 'ร้านค้า'
  }, [location.pathname])

  return (
    <ContentLayout title={title} backButton>
      <ShopFormView />
    </ContentLayout>
  )
}
